// @components
import {
  Card,
  CardBody,
  Typography,
} from "@material-tailwind/react";
import imageLogo from "../../assets/logo_ticket_win.png";
import "./index.css";
import 'notyf/notyf.min.css'; // Asegúrate de importar el CSS de Notyf
import AvisoPrivacidadComponent from "../../components/AvisoPrivacidadComponent";

function TermsConditions() {

  return (
    <section className="">
      <div className="mx-auto h-full grid place-items-center bg-colors-container">
        <Card shadow={false} className="md:m-8 py-8 md:px-8 border border-gray-300">
          <div className="flex justify-center align-center flex-col px-6 text-center">
            <div className="flex justify-center">
              <img src={imageLogo} alt="TicketWin APP" width={"250px"} />
            </div>
            <Typography
              variant="h1"
              color="blue-gray"
              className="mt-4 mb-2 !text-2xl lg:text-4xl"
            >
              Terminos & Condiciones
            </Typography>
        
          </div>

          <CardBody>
            <AvisoPrivacidadComponent />
          </CardBody>
        </Card>
      </div>
    </section>
  );
}

export default TermsConditions;
